import { Injectable } from '@angular/core';
import { AngularFirestore } from 'angularfire2/firestore';
import 'rxjs/add/operator/map';
import * as firebase from 'firebase';
import { HttpParams, HttpClient } from '@angular/common/http';
import { Globals } from '../../globals';
import { ProvidersServices } from '../providers/services';
import { TranslateService } from '@ngx-translate/core';
import { ToastController, LoadingController, AlertController } from 'ionic-angular';

//interface


@Injectable()
export class AdsServices {

    public firestore: any;
    public provider_exist: boolean = false;
    public element_exist: boolean = false;
    public actual_page: any;
    public type_ads: any;

    provider: any;
    providers: any;
    elements: any;
    elementsProviderFile: any;

    get_elements_done: boolean = false;

    constructor(public afs: AngularFirestore,
        public http: HttpClient,
        public globals: Globals,
        public providersServices: ProvidersServices,
        public alertCtrl: AlertController,
        public translate: TranslateService,
        public toastCtrl: ToastController,
        public loadingCtrl: LoadingController) {
        this.firestore = firebase.firestore();
    }

    getProviderFile(provider) {
        let loadingPopup = this.loadingCtrl.create({
            spinner: 'crescent',
            content: this.translate.instant('general-cargando-informacion-proveedor')
        });
        loadingPopup.present();
        const providersRef = this.firestore.collection('ads_providers').doc(provider.UID);

        providersRef.get().then(doc => {

            this.provider = doc.data();
            this.provider.UID = doc.id;
            //Comprovamos si el proveedor ya esta añadido
            this.searchProvider(this.provider);
            //Recuperamos todos los elementos de este proveedor
            this.getElementsProvider();
            loadingPopup.dismiss();
        });
    }
    getElementsAds(ads_number, ads_action_page) {
        this.elements = [];
        //Recuperem els elements
        const params = new HttpParams()
            .set('ads_location_country', this.globals.restaurant.address_country)
            .set('ads_location_state', this.globals.restaurant.address_state)
            .set('ads_type', 'display_product_ads')
            .set('ads_number', ads_number)
            .set('ads_action_page', ads_action_page)
            .set('uid_restaurant', this.globals.restaurant_uid);
        this.http.post(this.globals.analytics_path + 'ads_get_and_return', params, {})
            .subscribe(async res => {
                this.elements = res;
            });
    }
    async getProvidersAds(ads_number, ads_action_page) {
        this.providers = [];
        //Recuperem els proveidors per els ads de proveidor
        const params_provider_ad = new HttpParams()
            .set('ads_location_country', this.globals.restaurant.address_country)
            .set('ads_location_state', this.globals.restaurant.address_state)
            .set('ads_type', 'display_provider_ads')
            .set('ads_number', ads_number)
            .set('ads_action_page', ads_action_page)
            .set('uid_restaurant', this.globals.restaurant_uid);
        const response = this.http.post(this.globals.analytics_path + 'ads_get_and_return', params_provider_ad, {}).toPromise();
        return response;
    }
    async getElementsProvider() {
        this.get_elements_done = false;
        this.elementsProviderFile = [];
        //Buscamos los elementos de el proveedor
        const elementsRef = this.firestore.collection('ads_providers/' + this.provider.UID + '/products');


        await elementsRef.orderBy('name').get()
            .then(snapshot => {
                snapshot.forEach(async doc => {
                    var _elements = doc.data();
                    _elements.UID = doc.id;
                    _elements.provider = this.provider;
                    this.elementsProviderFile.push(_elements);
                });
            });
        this.get_elements_done = true;
    }

    trackFunction(action, action_in_page, ads_element_name, ads_element_ref, ads_provider_name, ads_provider_uid, click, contact, display, type) {
        var data = {
            "action": action,
            "action_in_page": action_in_page,
            "address_city_action": this.globals.restaurant.address_city,
            "address_country_action": this.globals.restaurant.address_country,
            "address_province_action": this.globals.restaurant.address_province,
            "ads_element_name": ads_element_name,
            "ads_element_ref": ads_element_ref,
            "ads_provider_name": ads_provider_name,
            "ads_provider_uid": ads_provider_uid,
            "click": click,
            "contact": contact,
            "display": display,
            "type": type,
            "uid_restaurant": this.globals.restaurant_uid
        };
        const params = new HttpParams()
            .set('track', JSON.stringify(data))
        this.http.post(this.globals.analytics_path + 'ads_track_call', params, {})
            .subscribe(async res => {
            });
    }

    async addProviderAndRefs(provider) {
        let alert = this.alertCtrl.create({
            title: this.translate.instant('ads-anadir-proveedor-ref'),
            message: this.translate.instant('ads-anadir-ing-prod'),
            buttons: [
                {
                    text: this.translate.instant('ads-anadir-solo-proveedor'),
                    handler: () => {
                        //Añadimos el proveedor
                        this.addProvider(provider);
                    }
                },
                {
                    text: this.translate.instant('ads-anadir-proveedor-ingredientes'),
                    handler: () => {
                        //Añadimos el proveedor
                        this.addProvider(provider);
                        //Añadimos todos los elementos de este proveedor
                        this.elementsProviderFile.forEach((item, index) => {
                            this.addIngredient(item);
                        })
                    }
                },
                {
                    text: this.translate.instant('ads-anadir-proveedor-productos'),
                    handler: () => {
                        //Añadimos el proveedor
                        this.addProvider(provider);
                        //Añadimos todos los elementos de este proveedor
                        this.elementsProviderFile.forEach((item, index) => {
                            this.addProduct(item);
                        })
                    }
                },
                {
                    text: this.translate.instant('general-cancelar'),
                    role: 'cancel',
                    handler: () => {
                    }
                },
            ]
        });
        alert.present();
    }
    async addProvider(provider) {

        let loadingPopup = this.loadingCtrl.create({
            spinner: 'crescent',
            content: this.translate.instant('instant-anadiendo-proveedor')
        });
        loadingPopup.present();
        await this.checkValues(provider);

        if (!provider.name) {
            provider['name'] = provider[1];
            provider['nif'] = provider[2];
            provider['email'] = provider[8];
            provider['phone'] = provider[6];
            provider['address'] = provider[3];
            provider['web'] = '';
        }
        //Añadimos el proveedor y todas sus referencias
        this.providersServices.afs.collection('providers').add({
            'UID_RESTAURANT': this.globals.restaurant_uid,
            'name': provider.name,
            'contact_name': '',
            'nif': provider.nif,
            'email': provider.email,
            'phone': provider.phone,
            'address': provider.address,
            'fixed_phone': '',
            'web': provider.web,
            'no_provider': '',
            'observations': '',
            'created_at': new Date(),
            'updated_at': new Date(),
            'ads_provider_uid': provider.UID
        }).then(doc => {
            let toast = this.toastCtrl.create({
                message: this.translate.instant('ads-provedor-anadido-correctamente'),
                duration: 3000,
                position: 'bottom'
            });
            toast.present();
            //Track cuando añadimos proveedor
            this.trackFunction("Click", this.actual_page, null, null, provider.name, provider.UID, 1, 0, 0, "click_provider_add");
            loadingPopup.dismiss();
        });
    }
    async addProduct(product) {
        var provider_uid;

        //Comprovamos si el proveedor ya esta añadido
        await this.searchProvider(product.provider);
        //Si el proveedor no esta añadido
        if (!this.provider_exist) {
            this.addProvider(product.provider);
        }
        //Recuperar el uid del proveeidor
        const providersRef = this.firestore.collection('providers');

        await providersRef.where('UID_RESTAURANT', '==', this.globals.restaurant_uid).where('ads_provider_uid', '==', product.provider.UID).get()
            .then(snapshot => {
                snapshot.forEach(doc => {
                    provider_uid = doc.id;
                });
            });

        var _provider = Array();
        _provider.push({
            uid: provider_uid,
            default: true,
            price_static: product.price,
            name_static: product.provider.name,
            pricetotal_static: product.price,
            tax_static: 0,
            updated_at: new Date(),
        });
        //Añadimos el producto
        this.firestore.collection('products').add({
            'UID_RESTAURANT': this.globals.restaurant_uid,
            'name': product.name,
            'name_en': product.name,
            'name_fr': product.name,
            'name_it': product.name,
            'name_de': product.name,
            'name_ca': product.name,
            'measurement': product.measurement,
            'stock': 0,
            'stock_alert': 0,
            'stock_max': 0,
            'sub_recipe': false,
            'tags': product.tags,
            'tags_static': product.tags.toString(),
            'pvp': 0,
            'pvp2': 0,
            'pvp3': 0,
            'price_static': product.price,
            'provider_static': product.provider.name,
            'providers': _provider,
            'created_at': new Date(),
            'updated_at': new Date(),
            'description_es': product.description,
            'description_en': product.description,
            'description_fr': product.description,
            'description_it': product.description,
            'description_de': product.description,
            'description_ca': product.description,
            'ads_element_uid': product.UID,

        }).then(doc => {
            // Añadir tags nuevos al array global
            if (product.tags && product.tags.length > 0) {
                this.globals.addTagsToGlobal(product.tags);
            }
            let toast = this.toastCtrl.create({
                message: this.translate.instant('ads-elementos-anadidos-correctamente'),
                duration: 3000,
                position: 'bottom'
            });
            toast.present();
            //Track cuando añadimos un elemento
            this.trackFunction("Click", this.actual_page, product.name, product.ref, product.provider.name, product.provider.UID, 1, 0, 0, "click_product_add");
        });
    }
    async addIngredient(ingredient) {
        var provider_uid;

        //Comprovamos si el proveedor ya esta añadido
        await this.searchProvider(ingredient.provider);

        //Si el proveedor no esta añadido
        if (!this.provider_exist) {
            this.addProvider(ingredient.provider);
        }
        //Recuperar el uid del proveeidor
        const providersRef = this.firestore.collection('providers');

        await providersRef.where('UID_RESTAURANT', '==', this.globals.restaurant_uid).where('ads_provider_uid', '==', ingredient.provider.UID).get()
            .then(snapshot => {
                snapshot.forEach(doc => {
                    provider_uid = doc.id;
                });
            });

        var _provider = Array();
        _provider.push({
            uid: provider_uid,
            default: true,
            price_static: ingredient.price,
            name_static: ingredient.provider.name,
            pricetotal_static: ingredient.price,
            tax_static: 0,
            updated_at: new Date(),
        });
        //Añadimos el ingrediente
        this.firestore.collection('ingredients').add({
            'UID_RESTAURANT': this.globals.restaurant_uid,
            'name': ingredient.name,
            'measurement': ingredient.measurement,
            'stock': 0,
            'stock_alert': 0,
            'stock_max': 0,
            'sub_recipe': false,
            'tags': ingredient.tags,
            'tags_static': ingredient.tags.toString(),
            'price_static': ingredient.price,
            'provider_static': ingredient.provider.name,
            'providers': _provider,
            'created_at': new Date(),
            'updated_at': new Date(),
            'ads_element_uid': ingredient.UID,
        }).then(doc => {
            let toast = this.toastCtrl.create({
                message: this.translate.instant('ads-elementos-anadidos-correctamente'),
                duration: 3000,
                position: 'bottom'
            });
            toast.present();
            //Track cuando añadimos un elemento
            this.trackFunction("Click", this.actual_page, ingredient.name, ingredient.ref, ingredient.provider.name, ingredient.provider.UID, 1, 0, 0, "click_product_add");
        });
    }

    async searchProvider(provider) {
        this.provider_exist = false;
        //Buscamos si el proveedor ya esta añadido
        const providersRef = this.firestore.collection('providers');

        await providersRef.where('UID_RESTAURANT', '==', this.globals.restaurant_uid).where('ads_provider_uid', '==', provider.UID).get()
            .then(snapshot => {
                snapshot.forEach(doc => {
                    this.provider_exist = true;
                });
            });
    }

    async searchElement(element) {
        this.element_exist = false;
        //Buscamos si el elemento ya esta añadido
        const productRef = this.firestore.collection('product');
        const ingredientRef = this.firestore.collection('ingredients');

        await productRef.where('UID_RESTAURANT', '==', this.globals.restaurant_uid).where('ads_element_uid', '==', element.UID).get()
            .then(snapshot => {
                snapshot.forEach(doc => {
                    this.element_exist = true;
                });
            });
        await ingredientRef.where('UID_RESTAURANT', '==', this.globals.restaurant_uid).where('ads_element_uid', '==', element.UID).get()
            .then(snapshot => {
                snapshot.forEach(doc => {
                    this.element_exist = true;
                });
            });
    }
    async contactProvider(provider) {
        let loadingPopup = this.loadingCtrl.create({
            spinner: 'crescent',
            content: this.translate.instant('general-enviando-email')
        });
        loadingPopup.present();

        //Track cuando contactamos con proveedor
        this.trackFunction("Click", this.actual_page, null, null, provider.name, provider.UID, 1, 1, 0, "click_provider_contact");

        loadingPopup.dismiss();
        let toast = this.toastCtrl.create({
            message: this.translate.instant('ads-email-enviado-correctamente'),
            duration: 3000,
            position: 'bottom'
        });
        toast.present();
    }

    async addElement(element, type) {
        //Comprovamos si el elemento ya esta añadido
        await this.searchElement(element);

        //Si no esta añadido
        if (!this.element_exist) {
            //Comprovamos si añaden un ingrediente o un producto
            if (type == "product") {
                //Añadimos el elemento al restuarante
                this.addProduct(element);
            } else {
                //Añadimos el elemento al restuarante
                this.addIngredient(element);
            }
        } else {
            let alert = this.alertCtrl.create({
                title: this.translate.instant('general-anadir-elemento'),
                message: this.translate.instant('genera-elemento-existe-volver-anadir'),
                buttons: [
                    {
                        text: this.translate.instant('general-si'),
                        handler: () => {
                            //Comprovamos si añaden un ingrediente o un producto
                            if (type == "product") {
                                //Añadimos el elemento al restuarante
                                this.addProduct(element);
                            } else {
                                //Añadimos el elemento al restuarante
                                this.addIngredient(element);
                            }
                        }
                    },
                    {
                        text: this.translate.instant('general-no'),
                        role: 'cancel',
                        handler: () => {
                        }
                    },
                ]
            });
            alert.present();
        }
    }

    randomProvidersElements() {
        var type = ['element', 'provider'];
        // Desconectamos anuncios de producto(element)
        var number = 1; //Math.floor(Math.random() * (1 - 0 + 1) + 0);
        this.type_ads = type[number];
    }

    checkValues(provider) {
        if (provider.name == undefined) {
            provider.name = '';
        }
        if (provider.nif == undefined) {
            provider.nif = '';
        }
        if (provider.address == undefined) {
            provider.address = '';
        }
        if (provider.province == undefined) {
            provider.province = '';
        }
        if (provider.city == undefined) {
            provider.city = '';
        }
        if (provider.phone == undefined) {
            provider.phone = '';
        }
        if (provider.country == undefined) {
            provider.country = '';
        }
        if (provider.email == undefined) {
            provider.email = '';
        }
        if (provider.contact_name == undefined) {
            provider.contact_name = '';
        }
        if (provider.web == undefined) {
            provider.web = '';
        }
    }
}



// WEBPACK FOOTER //
// ./src/pages/ads/services.ts